module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flip-container",
    class: {
      'flipped': _vm.isFlipped
    }
  }, [_c('div', {
    staticClass: "flipper"
  }, [_c('div', {
    staticClass: "front w-100"
  }, [_c('div', {
    staticClass: "col-sm-12 bg-lightest border-light card-height-1 d-flex flex-column radius-normal"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center w-100 h-100"
  }, [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "text-center darker font-weight-600 mt-4 fs-large"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "dark text-center fs-small"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.subTitle) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center w-100 mb-5 mt-4 info-holder"
  }, [_c('graph', {
    staticClass: "graph w-100",
    attrs: {
      "height": 100,
      "chartData": _vm.graphData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-super-big dark mt-1"
  }, [_vm._v(_vm._s(_vm.percent) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "fs-larger",
    class: _vm.labelColor
  }, [_vm._v(_vm._s(_vm.label))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "back w-100"
  }, [_c('div', {
    staticClass: "col-sm-12 bg-lightest border-light card-height-1 d-flex flex-column mt-3 radius-normal"
  }, [_c('span', {
    staticClass: "card-flip-btn",
    on: {
      "click": _vm.toggleCard
    }
  }, [_c('i', {
    staticClass: "ico-close medium fs-small pointer ml-auto"
  })]), _vm._v(" "), _c('div', {
    staticClass: "darker font-weight-600 mt-4 mb-3"
  }, [_vm._v("\n\t\t\t\t\tEdit Widget\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "dark fs-small mt-2"
  }, [_vm._v("\n\t\t\t\t\tThresholder (%)\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.treshold.red.percent),
      expression: "treshold.red.percent"
    }],
    staticClass: "text-center",
    attrs: {
      "type": "text",
      "size": "2"
    },
    domProps: {
      "value": (_vm.treshold.red.percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.treshold.red, "percent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ico-minus darkest mx-1"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.treshold.yellow.percent),
      expression: "treshold.yellow.percent"
    }],
    staticClass: "text-center",
    attrs: {
      "type": "text",
      "size": "2"
    },
    domProps: {
      "value": (_vm.treshold.yellow.percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.treshold.yellow, "percent", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn w-100",
    on: {
      "click": _vm.toggleCard
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-4 pr-0"
  }, [_c('div', {
    staticClass: "bg-color-6 tresholdBar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 px-3"
  }, [_c('div', {
    staticClass: "bg-color-4 tresholdBar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pl-0"
  }, [_c('div', {
    staticClass: "bg-color-3 tresholdBar"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ed589396", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed589396"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/cardGraphOccupancy.vue
// module id = 2919
// module chunks = 0